import { lazy, Suspense } from 'react';
import LoadingCom from '../../../components/LoadingCom';
import PageErrorBoundary from '../../../components/PageErrorBoundary';

const Step4 = lazy(() => import('./Index'));

export default function SuspendedStep4SetupPage(props: any) {
  return (
    <PageErrorBoundary>
      <Suspense fallback={<LoadingCom />}>
        <Step4 {...props} />
      </Suspense>
    </PageErrorBoundary>
  );
}
